import React from 'react';
import { Flex, ProgressCircle } from '@adobe/react-spectrum';

// Lightweight full-screen spinner for Suspense fallbacks. Replaces the heavier
// Loader from @apollo/dynamic-form so that package (and its jsonforms/ajv/moment
// dependencies) stays out of the initial bundle. ProgressCircle is already part
// of the Spectrum v3 bundle, so this adds no extra weight to the main chunk.
function FullScreenLoader() {
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      UNSAFE_style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 10000,
      }}
    >
      <ProgressCircle aria-label="Loading" isIndeterminate size="L" />
    </Flex>
  );
}

export default FullScreenLoader;
